
import { Box } from '@mui/system';
import '../App.css';
import { useState, useContext } from 'react';
import styled from '@emotion/styled'
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useChangePasswordMutation } from '../features/auth/authApiSlice';
import { GlobalStateContext } from '../store/GlobalState';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../features/auth/authSlice';
import { useTranslation } from "react-i18next";
import MainContent from '../components/MainContent';

const loginPageInputStyle = {
    height: '60px',
    width: '400px',
    borderRadius: 0,
    fontSize: 'calc(14px + 0.4vw)',
    paddingLeft: '12px',
    fontWeight: 300

}

const loginPageContainerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: 'calc(16px + 0.4vw)',
    width: '573px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageHeadingContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: '573px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageLabelContainer = styled.label`
    width: 173px;
    @media (max-width: 1080px) {
      /* Styles for small screens */
      width: 160px;
    }
    flex-wrap: wrap;
`;

const LoginPageLoginButton = styled.button`
    width: 400px;
    background: #21125B;
    color: white;
    font-size: calc(12px + 0.4vw);
    border-radius: 20px;
    height: 62px;
    font-weight: 600;
    cursor: pointer;
`


const LoginPageHeading2 = styled.p`
    font-weight: 600;
    border-bottom: 5px solid #21125B;
    padding-bottom: 10px;
    font-size: calc(32px + 0.4vw);
    margin-bottom: 50px;
    margin-top: 32px;
`

const WrongPassword = styled.span`
    font-size: 16px;
    color: red;
`

const ChangePasswordPage = () => {
    const { t } = useTranslation();
    const globalState = useContext(GlobalStateContext)
    const [changePassword] = useChangePasswordMutation()
    const [currentPassword, setCurrentPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleKeyDown = async function (e: any) {
        if (e.key === 'Enter') {
            // await handleLogin(e)
            await handleChangePassword(e)
        }
    }

    const handleChangePassword = async (e: any) => {
        e.preventDefault()
        if (currentPassword === "")
            alert("Cannot empty password.")
        else if (newPassword === "")
            alert("Cannot empty new password.")
        else if (currentPassword === newPassword)
            alert("Cannot use the same pssword.")
        else {
            try {
                await changePassword({ currentPassword: currentPassword, newPassword: newPassword }).unwrap().then(
                    (result) => {
                        const loginResponse = JSON.parse(result);
                        const { accessToken, refreshToken } = loginResponse;
                        const { token: refreshTokenToken, expires: refreshTokenExpires } = refreshToken;
                        // console.log("localStorage.getItem('user')", localStorage.getItem('user'))
                        const user = localStorage.getItem('user')
                        dispatch(
                            setCredentials({
                                user: user,
                                refreshToken: refreshTokenToken,
                                accessToken: accessToken,
                                expires: refreshTokenExpires
                            })
                        );
                        localStorage.setItem('user', user || "");
                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('refreshToken', refreshTokenToken);
                        localStorage.setItem('expires', refreshTokenExpires);

                        globalState.setAccessToken(accessToken)
                        globalState.setRefreshToken(refreshTokenToken)
                        globalState.setExpires(refreshTokenExpires)
                        alert("Password changed.")
                        navigate("/recordDetail/latest")
                    }
                )
            } catch (err: any) {
                console.log(err);
                // setErrorMessage(err)
                alert("Please enter the correct pssword!")
            }
        }

    }

    return (
        <MainContent type={""}>
            <Grid container spacing={0}>
                {/* <Grid item xs={12} md={6}>
                    {/* Photo
                    <LoginPageImage src={loginPageImage} alt="login page photo" />
                </Grid> */}
                <Grid item xs={12} md={12}>
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading2>{t("Change Password")}</LoginPageHeading2>
                    </Box>

                    {/* Input Boxes */}

                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer>{("Current Password:")}</LoginPageLabelContainer>
                        <input name="passowrd" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} style={loginPageInputStyle} onKeyDown={handleKeyDown} />
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer>{("New Password:")}</LoginPageLabelContainer>
                        <input name="newPassword" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={loginPageInputStyle} onKeyDown={handleKeyDown} />
                    </Box>

                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{errorMessage}</WrongPassword>
                    </Box>

                    {/* Buttons */}
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleChangePassword}>{t("Change Password")}</LoginPageLoginButton>
                    </Box>
                    {/* <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleBackButton}>{t("Back")}</LoginPageLoginButton>
                    </Box> */}
                </Grid>
            </Grid>
        </MainContent>
    );
};

export default ChangePasswordPage;
